import { isEmpty } from "lodash";
import { DateTime } from "luxon";
import { parse } from "node-html-parser";

export const navigationsFooter = [
  {
    name: "Accueil",
    href: "#home",
  },
  {
    name: "Contact",
    href: "#contact",
  },
  {
    name: "Support",
    href: "#",
  },
  {
    name: "Privacy",
    href: "/assets/Politique de confidentialité InfinX Mobility .pdf",
  },
];

export const generateCode = (length: number): string => {
  let code = "";
  for (let i = 0; i < length; i++) {
    code += Math.floor(Math.random() * 10); // Génère un chiffre entre 0 et 9
  }
  return code;
};

export const extractFirstImageSrc = (html: string): string | null => {
  const regex = /<img[^>]+src="([^">]+)"/i;
  const match = regex.exec(html);
  return match ? match[1] : null;
};

export const removeImageTags = (html: string): string => {
  return html.replace(/<img[^>]*>/g, "");
};

export const formatDateTimeWithDay = (dateString: string, hours?: boolean) => {
  if (!isEmpty(dateString)) {
    const date = DateTime.fromISO(dateString);

    return date.toFormat("MMMM, dd yyyy");
  }

  return "";
};
